import React, { useState, useEffect } from "react";
import { SearchNangCao } from "./SearchNangCao";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../actions/DanhSachHopDongChoDuyet";

export const SearchBarDesktop = ({}) => {
  const initTrangThai = {
    TrangThaiCombo: [
      { value: "-1", label: "Tất cả" },
      { value: "5", label: "Chờ duyệt vay" },
      { value: "6", label: "Chờ nhận tiền" },
    ],
  };
  const [dataTrangThai, setdataTrangThai] = useState(
    initTrangThai.TrangThaiCombo
  );

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    dispatch(getListHopDongChoDuyet(dataSearch));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListHopDongChoDuyet(dataSearch));
    }
  }; //sự kiện tìm kiếm enter
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-25">
          <label className="font-color-default font-bold">
             Tìm kiếm
          </label>
          <input
            type="text"
            className="form-control input-sm "
            placeholder="Tên, SĐT, CCCD khách hàng"
            value={dataSearch.customerName}
            onChange={updateTextValue("customerName")}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Trạng thái</label>
          <select
            name="Trạng thái"
            className="selectBox form-control input-sm"
            value={dataSearch.status}
            onChange={updateDropdown("status")}
          >
            {dataTrangThai &&
              dataTrangThai.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
          <label className="font-color-default font-bold"> &nbsp;</label>
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
